module.exports = __webpack_public_path__ + "static/media/fallout.968140f0.png";